import {
	Checkbox,
	Collapse,
	Dialog,
	DialogContent,
	DialogActions,
	DialogTitle,
	FormControlLabel, DialogContentText
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React from 'react';
import {InformativaPrivacy} from '../../widgets/utils/InformativaPrivacy';

export const PrivacyDialog = ({open, onClose, read, setRead}) => {
	return (
		<Dialog
			maxWidth={"md"}
			open={open}
			fullWidth>
			<DialogTitle>Informativa Privacy</DialogTitle>
			<DialogContent>
				<DialogContentText component={"div"}>
					<InformativaPrivacy/>
					<Box display="flex" flexDirection="row-reverse">
						<FormControlLabel
							labelPlacement="start"
							control={<Checkbox
								checked={read}
								onChange={() => setRead(!read)}
								name="checkedA"/>}
							label="Ho letto integralmente e compreso l'informativa sul trattamento dei dati personali"
						/>
					</Box>
				</DialogContentText>
				<Collapse in={read}>
					<Typography>QUI CI SCRIVO COME INSERIRE IL FILE</Typography>
				</Collapse>
			</DialogContent>
			<DialogActions>
				<Button
					variant={"contained"}
					disabled={!read}
					onClick={() => onClose(false)}
					color={"secondary"}>
					Confermo
				</Button>
			</DialogActions>
		</Dialog>
	)
}